import React, {Component} from 'react';
import Styles from './style.css';

class SignupAdsInstagramCanvas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            image: null,
        };
    };

    componentDidMount() {
        this._updateData();
    }

    _updateData() {
        this.setState({
            image: this.props.image,
        }, () => {
            console.log(this.state);
        });
    }

    render() {
        return (
            <div className={Styles.imagesContainerItem}>
                {
                    this.state.image &&
                    <div className={Styles.imagesContainerItemInner}>
                        {
                            <div style={{backgroundImage: "url(" + this.state.image.url + ")"}} className={Styles.imagesContainerItemInnerUploadImage}/>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default SignupAdsInstagramCanvas;


// WEBPACK FOOTER //
// ./src/components/signup-ads-instagram-canvas/component.js